import { Zoom } from "@material-ui/core"
import { Link } from "gatsby"
import React from "react"
import { Row, Col, Container } from "react-bootstrap"

import { PlatformGlobeContainer } from "../../styles/Components/SingleInstance/PlatformGlobe"
import Heading from "../../utils/OptimizedHeading"

import { LocationTooltip } from "./LocationTooltip"

const PlatformGlobe = ({ grid }) => (
  <PlatformGlobeContainer
    className={`bg-plum container-${
      grid !== "" ? grid?.toLowerCase() : "normal"
    }`}
  >
    <Container>
      <Row className="align-self-center content">
        <Col lg={7} md={10} className="globe-content">
          <div className="globe-bg d-flex align-items-center">
            <div>
              <div className="pb-4">
                <p>
                  <strong>20 years</strong> of B2B experience
                </p>
                <div className="clickatell-green-bg rounded" />
              </div>
              <div className="pb-4">
                <p>
                  <strong>15 000+</strong> clients
                </p>
                <div className="clickatell-green-bg rounded" />
              </div>
              <div className="pb-4">
                <p>
                  <strong>10+ billion</strong> annual messages sent
                </p>
                <div className="clickatell-green-bg rounded" />
              </div>
              <div className="pb-4">
                <p>
                  <strong>1000+</strong> mobile networks
                </p>
                <div className="clickatell-green-bg rounded" />
              </div>
              <div className="pb-4">
                <p>
                  <strong>220</strong> territories
                </p>
                <div className="clickatell-green-bg rounded" />
              </div>
            </div>
          </div>
        </Col>
        <Col lg={5}>
          <div className="heading-container d-flex align-items-center h-100">
            <div>
              <p className="heading-kicker eyebrow">SMS</p>
              <Heading
                type="Heading 2"
                string="Reach and engage with 85% of the world’s population in real-time"
                className="heading"
              />
              <Row className="description">
                <Col lg={12} md={6}>
                  <h3>Global Reach</h3>
                  <p>
                    Our infrastructure covers over 220 territories and 1 000+
                    networks, reaching 6 billion mobile phone users.
                  </p>
                </Col>
                <Col lg={12} md={6}>
                  <h3>Intelligent Routing</h3>
                  <p>
                    We select the highest quality routes available at the time
                    of sending.
                  </p>
                </Col>
                <Col lg={12} md={6}>
                  <h3>Two-Way Text Messaging</h3>
                  <div className="na-enquiry-text">
                    <p>
                      We offer personalized&nbsp;
                      <LocationTooltip
                        TransitionComponent={Zoom}
                        title="A short code is a memorable 5 or 6 digit number ideal for marketing and promotional SMS campaigns. Short codes are easily remembered and ideal for sending bulk text messages from business-to-consumer."
                        placement="bottom"
                        arrow
                      >
                        <span className="tooltip-label">short codes</span>
                      </LocationTooltip>
                      &nbsp; or &nbsp;
                      <LocationTooltip
                        TransitionComponent={Zoom}
                        title="A long number is a cost-effective dedicated telephone number, usually 16 digits in length, that enables your business to receive replies for booking confirmations and marketing campaigns from local and selected international destinations."
                        placement="bottom"
                        arrow
                      >
                        <span className="tooltip-label">long numbers</span>
                      </LocationTooltip>
                      &nbsp; that will enable you to engage with your customers
                      via SMS.
                    </p>
                  </div>
                </Col>
                <Col lg={12} md={6}>
                  <h3>
                    10-Digit Long Codes (10DLC) for A2P messaging in the U.S.
                  </h3>
                  <p className="mb-0">
                    Use a 10DLC phone number for compliant and cost-effective
                    messaging at scale.
                    <Link
                      to="/clickatell-10dlc-cm/"
                      className="hyperlink-white"
                    >
                      Learn more about 10DLC.
                    </Link>
                  </p>
                  <br />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </PlatformGlobeContainer>
)

export default PlatformGlobe
